<template>
<div class="chapter">
<div class="inner_page">
<div class="page">
<p class="center"><img alt="" id="img_01" src="OEBPS/images/aaa.jpg"/></p>
<p class="caption">Churchill at Lille, 28 October 1918, watching a march-past</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// htp.vue?8413d774